import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { fishkillConfig } from "./data";

export default function FishkillPage() {
  return <CityPageTemplate config={fishkillConfig} />;
}